import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import Section from './Section';
interface HeroSectionProps {
  fadeInUp: any;
  staggerContainer: any;
}
const HeroSection: React.FC<HeroSectionProps> = ({
  fadeInUp,
  staggerContainer
}) => {
  const navigate = useNavigate();
  return <Section variants={staggerContainer} initial="initial" animate="animate" className="items-center min-h-screen relative overflow-hidden">
      {/* Background Effects Luxuosos com vermelho/rosa/roxo */}
      <div className="absolute inset-0">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-gradient-to-r from-luxury-red/20 to-luxury-purple/20 rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-gradient-to-l from-luxury-darkPink/15 to-luxury-red/15 rounded-full blur-3xl"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gradient-to-br from-luxury-purple/10 via-transparent to-luxury-mediumPink/10 rounded-full blur-[100px]"></div>
      </div>

      <div className="relative text-center max-w-5xl mx-auto z-10">
        <motion.h1 variants={fadeInUp} className="text-4xl md:text-6xl lg:text-7xl font-bold mb-8 leading-tight text-white">
          Conexões com classe.
          <br />
          <span className="bg-gradient-to-r from-luxury-red via-luxury-mediumPink to-luxury-purple bg-clip-text text-transparent">Acordos com desejo.</span>
          <br />
          <span className="block mt-4">
            Experiências com propósito.
          </span>
        </motion.h1>

        <motion.p variants={fadeInUp} className="text-xl md:text-2xl text-white/90 max-w-4xl mx-auto leading-relaxed mb-8">Este não é mais um aplicativo. É um acesso restrito ao que poucos podem viver.</motion.p>

        <motion.p variants={fadeInUp} className="text-lg md:text-xl text-white/70 max-w-3xl mx-auto leading-relaxed mb-12">
          Bem-vindo ao ambiente onde desejo se alia ao poder, e elegância é o mínimo exigido.
        </motion.p>

        <motion.div variants={fadeInUp}>
          <Button size="lg" className="bg-gradient-to-r from-luxury-red via-luxury-mediumPink to-luxury-purple hover:from-luxury-red/90 hover:via-luxury-mediumPink/90 hover:to-luxury-purple/90 text-white px-12 py-6 text-xl rounded-full transition-all duration-300 transform hover:scale-105 shadow-2xl shadow-luxury-red/20" onClick={() => navigate('/auth')}>
            Começar agora
            <ArrowRight className="ml-3 w-6 h-6" />
          </Button>
        </motion.div>
      </div>
    </Section>;
};
export default HeroSection;